import React from 'react';
import Select from 'components/shared/select';

const PerPage = ({ onChange, value, options }) => (
  <div className="Table-perPage">
    <label htmlFor="perPage" className="u-showBelowMD">
      {t('common.per_page')}
    </label>
    <label htmlFor="perPage" className="u-hideBelowMD">
      {t('common.rows_per_page')}
    </label>
    <Select
      className="ml-8"
      id="perPage"
      value={value}
      onChange={e => onChange(parseInt(e.target.value, 10))}
    >
      {options.map(option => (
        <option key={option} value={option} children={option} />
      ))}
    </Select>
  </div>
);

PerPage.defaultProps = {
  options: [10, 25, 50, 100],
};

export default PerPage;
